import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { EventListService } from './../core/service/grid-data/grid-data-event.service';
import { TaskModule } from './../task/task.module';
import { MessageModule } from './../message/message.module';
import { CaseHistoryComponent } from './case-history/case-history.component';
import { CaseDetailComponent } from './case-detail/case-detail.component';
import { NgModule } from '@angular/core';
import { CaseListComponent } from './case-list/case-list.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { CaseListService } from '../core/service/grid-data/grid-data-case.service';
import { CaseAssignComponent } from './case-assign/case-assign.component';
import { CaseChangePriorityComponent } from './case-change-priority/case-change-priority.component';
import { NotesModule } from '../notes/notes.module';
import { FlagModule } from '../flag/flag.module';
import { DocumentModule } from '../document/document.module';
import { CaseDetailSummaryComponent } from './case-detail/case-detail-summary/case-detail-summary.component';
import { CaseDetailEventComponent } from './case-detail/case-detail-event/case-detail-event.component';
import { EventModule } from '../event/event.module';
import { AppointmentModule } from '../appointment/appointment.module';
import { TaskCardComponent } from '../task/task-card/task-card.component';
import { TeamModule } from '../team/team.module';
import { PatientEditModule } from '../shared/patient-edit/patient-edit.module';
import { CaseMemberComponent } from './case-member/case-member.component';
import { PinnedResourceModule } from '../pinned-resource/pinned-resource.module';
import { CaseEnrollmentModule } from '../shared/case-enrollment/case-enrollment.module';
import { InsuranceModule } from '../insurance/insurance.module';
import { TaskAddModule } from '../shared/task-add/task-add.module';
import { MemberAssessmentModule } from '../shared/member-assessment/member-assessment.module';
import { OtherCaseListService } from '../core/service/grid-data/grid-data-other-cases.service';
import { ContactHistoryModule } from '../contact-history/contact-history.module';
import { CaseDetailSummaryTaskGridComponent } from './case-detail/case-detail-summary/case-detail-summary-task-grid/case-detail-summary-task-grid.component';
import { CaseListDetailComponent } from './case-list-detail/case-list-detail.component';
import { ReferralModule } from '../referral/referral.module';

@NgModule({
  imports: [
    SharedModule,
    TaskModule,
    MessageModule,
    NotesModule,
    FlagModule,
    DocumentModule,
    EventModule,
    AppointmentModule,
    TeamModule,
    PatientEditModule,
    PinnedResourceModule,
    CaseEnrollmentModule,
    InsuranceModule,
    TaskAddModule,
    MemberAssessmentModule,
    ContactHistoryModule,
    NgbModule,
    ReferralModule
  ],
  declarations: [
    CaseDetailComponent,
    CaseHistoryComponent,
    CaseListComponent,
    CaseAssignComponent,
    CaseChangePriorityComponent,
    CaseDetailSummaryComponent,
    CaseDetailEventComponent,
    TaskCardComponent,
    CaseMemberComponent,
    CaseDetailSummaryTaskGridComponent,
    CaseListDetailComponent,
  ],
  providers: [
    CaseListService,
    OtherCaseListService,
    EventListService
  ],
  exports: [
    CaseMemberComponent,
    CaseListDetailComponent
  ]
})
export class CaseModule { }
